import * as React from 'react';
import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseCorrectAnswer = ({ className }: IProps) => (
    <svg
        className={className}
        viewBox="0 0 78 78"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            fill="rgb(0, 152, 120)"
            d="M38.999,0.12 C60.546,0.12 78.12,17.453 78.12,39.0 C78.12,60.546 60.546,78.12 38.999,78.12 C17.453,78.12 0.12,60.546 0.12,39.0 C0.12,17.453 17.453,0.12 38.999,0.12 Z"
        />
        <path
            fillRule="evenodd"
            fill="rgb(255, 255, 255)"
            d="M22.64,31.701 L41.298,50.935 L34.935,57.298 L15.701,38.64 L22.64,31.701 Z"
        />
        <path
            fillRule="evenodd"
            fill="rgb(255, 255, 255)"
            d="M64.298,28.64 L35.64,57.298 L28.701,50.935 L57.935,21.701 L64.298,28.64 Z"
        />
    </svg>
);

export const CorrectAnswer = styled(BaseCorrectAnswer)``;
